export default {"src":"/_next/static/media/icon_waiting_spinner.9217a79f.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};